import type { PipelineStep } from '../types';
import type { HljsLanguage } from '../HighlightedCode';

export const STEP_LABELS: Partial<Record<PipelineStep, string>> = {
  idle: '',
  indexing: 'Indexing files…',
  retrieving: 'Retrieving context…',
  planning: 'Planning actions…',
  executing: 'Executing tools…',
  validating: 'Validating…',
  diagnosing: 'Diagnosing errors…',
  streaming: 'Generating response…',
  complete: 'Done',
  error: 'Error',
  runTests: 'Running test assertions…',
  writeTests: 'Writing test specs…',
  editTests: 'Editing test specs…',
};

export function inferLanguageFromPath(path?: string): HljsLanguage {
  if (!path) return 'typescript';
  const lower = path.toLowerCase();
  if (lower.endsWith('.tsx')) return 'tsx';
  if (lower.endsWith('.ts')) return 'typescript';
  if (lower.endsWith('.jsx')) return 'jsx';
  if (lower.endsWith('.js') || lower.endsWith('.mjs') || lower.endsWith('.cjs')) return 'javascript';
  if (lower.endsWith('.json')) return 'json';
  if (lower.endsWith('.html') || lower.endsWith('.htm')) return 'html';
  if (lower.endsWith('.css') || lower.endsWith('.scss')) return 'css';
  return 'typescript';
}
